import { verifPreviousMail } from 'app/modules/account/service';
import { declarerSinistre, getClaimsClientsForActiveSubscription, getclaimsListBySubscriptionNumber } from 'app/modules/claim/service';

export const consultContractAction = param => {
  param.redirect.push({
    pathname: `/contracts/` + param.subNumber,
  });
};

export const verifPreviousMailAction = param => {
  param.dispatchor(verifPreviousMail(param.number, param.mailValue));
};

export const redirectFoundSubsAction = param => {
  param.redirect();
};

export const declarer = param => {
  param.dispatch(declarerSinistre(param.subNumber));
};

export const getClaimList = param => {
  if (param.subNumber) {
    param.dispatch(getclaimsListBySubscriptionNumber(param.subNumber));
  } else {
    param.dispatch(getClaimsClientsForActiveSubscription());
  }
  // param.openPopUp(true);
  param.redirect.push({
    pathname: `/claims`,
    state: { subNumber: param.subNumber },
  });
};

export const updatePersonalInfo = param => {
  param.updateAddress(true);
};

export const cancelCotisation = param => {
  param.setpay(false);
};

export const actionMap = new Map([
  ['CONSULT_CONTRACT', consultContractAction],
  ['DECLARE_CLAIM', declarer],
  ['CLAIM_ACTION', getClaimList],
  ['FOLLOW_CLAIM_LIST', getClaimList],
  ['CANCEL_INFO_USER', updatePersonalInfo],
  ['VERIF_PREVIOUS_MAIL_ACTION', verifPreviousMailAction],
  ['REDIRECT_FOUNDS_SUBS', redirectFoundSubsAction],
  ['SUBSCRIPTION_SEARCH', redirectFoundSubsAction],
  ['CANCEL_COTISATION_USER', cancelCotisation],
]);
